import {
    Component,
    Input,
    Output,
    OnInit,
    EventEmitter,
    OnChanges,
    SimpleChange } from '@angular/core';

declare var jQuery: any;

@Component({
    selector: 'itpx-multi-select',
    templateUrl: './multi-select.component.html',
    styleUrls: [ './multi-select.component.css' ]
})
export class MultiSelectComponent {
    @Input() dictionary: any;
    @Input() name: string;
    @Input() data: Array<string> = [];
    @Input() returnType: string;
    @Input() pipeParam: string;
    @Input() isDisabled: boolean = false;
    @Output() change = new EventEmitter();

    private items: Array<string> = [];
    private dict: any = { };

    ngOnChanges(changes: {[propKey: string]: SimpleChange}) {
        this.dict = this.dictionary;
        if(changes['data']) {
            this.items = this.data || [];
        }
    }

    private onItemSelect(event: any) {
        let item = event.target.value;
        let itemId = '#' + item;
        jQuery(itemId).attr('disabled', 'disabled');
        if (!item) return;
        let index = this.items.indexOf(item, 0);
        if (index === -1) this.items.push(item);
        event.target.value = '';
        this.emitChange();
    }

    private getKeys(map: any) {
        return Object.keys(map);
    }

    private onItemRemove(item: string) {
        let itemId = '#' + item;
        jQuery(itemId).removeAttr('disabled');
        let index = this.items.indexOf(item, 0);
        if (index > -1) this.items.splice(index, 1);
        this.emitChange();
    }

    private emitChange() {
        this.change.emit({
            items: this.items
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/multi-select/multi-select.component.ts